// Peças do visual dos relatórios (as do Relatório de estudos, texto 11e D), usadas também pelo
// Relatório de leitura e mídia (texto 16): ◀ período ▶, o total grande no topo e o gráfico de barras.
import type { ReactNode } from 'react';
import { Pressable, Text, View } from 'react-native';
import { C } from '../theme';

/** ◀ título do período (e as datas) ▶. Sem onAnterior/onProximo (datas à escolha), as setas somem. */
export function NavPeriodo({ cor, titulo, datas, onAnterior, onProximo, podeProximo = true }:
  { cor: string; titulo: string; datas: string; onAnterior?: () => void; onProximo?: () => void; podeProximo?: boolean }) {
  return (
    <View style={{ flexDirection: 'row', alignItems: 'center', gap: 10 }}>
      {onAnterior ? <Pressable onPress={onAnterior} hitSlop={10}><Text style={{ color: cor, fontSize: 22 }}>◀</Text></Pressable> : <View style={{ width: 22 }} />}
      <View style={{ flex: 1, alignItems: 'center' }}>
        <Text style={{ color: C.text, fontWeight: '800' }}>{titulo}</Text>
        <Text style={{ color: C.sub, fontSize: 12 }}>{datas}</Text>
      </View>
      {onProximo ? <Pressable onPress={() => podeProximo && onProximo()} hitSlop={10}><Text style={{ color: podeProximo ? cor : C.mute, fontSize: 22 }}>▶</Text></Pressable> : <View style={{ width: 22 }} />}
    </View>
  );
}

/** O total grande no topo, com a legenda e (opcional) a linha de baixo. */
export function CartaoTotal({ valor, legenda, children }: { valor: string; legenda: string; children?: ReactNode }) {
  return (
    <View style={{ backgroundColor: C.card, borderRadius: 16, padding: 14, alignItems: 'center' }}>
      <Text style={{ color: C.text, fontSize: 30, fontWeight: '900' }}>{valor}</Text>
      <Text style={{ color: C.sub, fontSize: 12 }}>{legenda}</Text>
      {children}
    </View>
  );
}

/** Barras por dia (ou por mês). largas: poucas barras (semana), com o valor em cima. */
export function Barras({ valores, rotulos, cor, largas, rotuloValor }: { valores: number[]; rotulos: string[]; cor: string; largas: boolean; rotuloValor?: (v: number) => string }) {
  const max = Math.max(1, ...valores);
  return (
    <View style={{ flexDirection: 'row', alignItems: 'flex-end', gap: largas ? 6 : 2, height: 120, backgroundColor: C.card, borderRadius: 16, padding: 12 }}>
      {valores.map((v, i) => (
        <View key={i} style={{ flex: 1, alignItems: 'center', gap: 4 }}>
          {largas && <Text style={{ color: C.sub, fontSize: 9 }}>{v ? (rotuloValor ? rotuloValor(v) : String(v)) : ''}</Text>}
          <View style={{ width: '70%', height: Math.max(2, (v / max) * 64), borderRadius: largas ? 4 : 2, backgroundColor: v ? cor : C.card2 }} />
          {largas ? <Text style={{ color: C.sub, fontSize: 10 }} numberOfLines={1}>{rotulos[i]}</Text>
            // barras finas (mês): o número do dia pode passar da largura da barra, sem cortar ("2…")
            : <Text style={{ color: C.sub, fontSize: 8, width: 18, textAlign: 'center' }}>{rotulos[i]}</Text>}
        </View>
      ))}
    </View>
  );
}
